import React from 'react';
import * as styles from './related-products.module.css';
import CtaLink from '../Global/CtaLink';
import CtaButton from '../Global/CtaButton';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';
import { ProductDescription } from '../../templates/StructuredDataContext';
import { getMultiChoice } from '../Global/DataUtils';
import RichText from '../Global/RichText';
import GatsbyImage from 'gatsby-image/withIEPolyfill';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

interface Props {
    product: ProductPagePreview;
    productCtaLabel?: string;
    truncateLines?: number;
    productStyle?: string;
    ctaStyle?: string;
    backgroundColor?: string;
    fontColor?: string;
    customCtaLink?: string;
    useCustomCtaLocation?: boolean;
}

const ProductTile: React.FC<Props> = ({
    productCtaLabel,
    customCtaLink,
    useCustomCtaLocation,
    product,
    truncateLines,
    productStyle,
    ctaStyle,
    backgroundColor,
    fontColor,
}) => {
    const authorStyles =
        backgroundColor || fontColor
            ? {
                  backgroundColor: backgroundColor,
                  color: fontColor,
              }
            : undefined;

    const ctaColor = fontColor || '#505251';

    const productDescription = product.elements.page_components.value.filter(
        (component) =>
            component.__typename ===
            'kontent_item_component___product_description'
    )[0] as ProductDescription;

    const productElements = productDescription.elements;

    const productImageUsage = getMultiChoice(
        productElements.related_product_image_usage
    );

    const productImage =
        productImageUsage === 'use_image_gallery_image'
            ? productElements?.description_image?.value[0]?.elements.file
                  ?.value[0]
            : productElements?.related_product_image?.value[0]?.elements.file
                  ?.value[0];

    return (
        <div className={productStyle} style={authorStyles}>
            {productImage && (
                <CtaButton
                    href={
                        useCustomCtaLocation && customCtaLink
                            ? customCtaLink
                            : product.elements?.slug.url
                            ? product.elements?.slug.url
                            : 'undefined'
                    }
                    target="_self"
                >
                    <GatsbyImage
                        //@ts-ignore
                        fluid={productImage.fluidRelatedProducts}
                        alt={productImage?.description || productImage?.name}
                        fadeIn={false}
                    />
                </CtaButton>
            )}
            <div className={styles.productDetails}>
                {productElements.product_display_name && (
                    <h3>{productElements.product_display_name?.value}</h3>
                )}
                <div className={styles.description}>
                    {productElements.sub_title?.value && (
                        <div className={styles.productSubtitle}>
                            {productElements.sub_title.value}
                        </div>
                    )}
                    {productElements?.short_description &&
                        RichText(productElements?.short_description)}
                </div>
                <div className={ctaStyle}>
                    <CtaLink
                        href={
                            useCustomCtaLocation && customCtaLink
                                ? customCtaLink
                                : product.elements?.slug.url
                        }
                        target="_self"
                        color={ctaColor}
                    >
                        {productCtaLabel}
                    </CtaLink>
                </div>
            </div>
        </div>
    );
};

export default ProductTile;
